import React from 'react';
import PropTypes from 'prop-types';

import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrFlexRow from 'client/components/SrFlexRow/SrFlexRow';

const DEFAULT_ERROR_MESSAGE = 'Sorry, this can’t be loaded.';

const SrMonitorErrorCard = ({
  monitorName,
  errorMessage,
  noCard,
}) => {

  const SrLinkOrDiv = noCard ? 'div' : SrCard;

  return (
    <SrLinkOrDiv>
      <SrFlexRow>
        <SrText
          font='greycliff'
          fontSize='20px'
          weight='800'
        >
          {monitorName}
        </SrText>
      </SrFlexRow>
      <SrFlexRow
        marginTop='5px'
      >
        <SrText
          font='greycliff'
          color='orange300'
          fontSize='16px'
          weight='600'
        >
          {errorMessage || DEFAULT_ERROR_MESSAGE}
        </SrText>
      </SrFlexRow>
    </SrLinkOrDiv>
  );
};

SrMonitorErrorCard.propTypes = {
  monitorName: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  noCard: PropTypes.bool,
};

export default SrMonitorErrorCard;
